import React, { useEffect, useState } from 'react';

import {
    Select,
    SelectTrigger,
    SelectValue,
    SelectContent,
    SelectItem
} from 'src/@/components/ui/select';
import { Checkbox } from 'src/@/components/ui/checkbox';
import { Input } from 'src/@/components/ui/input';
import { Switch } from 'src/@/components/ui/switch';

export default function HorariosDeAtendimento({
    diasSemana,
    dataAgente,
    scheduleService,
    changeCustomScheduleService,
    customScheduleService,
    changeScheduleService
}) {

    console.log('scheduleService', scheduleService);
    
    

    return (
        <div className="p-2">
            <h2 className="text-md font-bold mb-4">Horários de Atendimento</h2>
            <div className="flex items-center space-x-4 mb-6">

                <Switch
                    checked={dataAgente?.config?.customServiceSchedule}
                    onCheckedChange={changeCustomScheduleService}
                />
                <label htmlFor="dias-customizados" className="text-sm">
                    Horário customizado
                </label>
            </div>

            {
                dataAgente?.config?.customServiceSchedule &&
                <div className="space-y-4 p-2 rounded-lg">
                    {scheduleService.map((horario, index) => (
                        <div key={index} className="flex">
                            <div className="flex items-center gap-4">
                                <Checkbox
                                    checked={horario.ativo}
                                    onCheckedChange={(ativo) => changeScheduleService(index, "ativo", ativo)}
                                />
                                <span className="w-32 text-sm">{`${horario.dia}`}</span>
                            </div>

                            <div className="flex flex-row gap-2 items-center w-full">
                                <Input
                                    type="time"
                                    value={horario.inicio}
                                    onChange={(e) => changeScheduleService(index, "inicio", e.target.value)}
                                    className="w-24 h-8"
                                />
                                <span>até</span>
                                <Input
                                    type="time"
                                    value={horario.fim}
                                    onChange={(e) => changeScheduleService(index, "fim", e.target.value)}
                                    className="w-24 h-8"
                                />
                            </div>
                        </div>
                    ))}
                </div>
            }



        </div>
    );
}
